module.exports = __webpack_public_path__ + "static/media/industries-lead-acid-s.475c61fe.webp";